// extracted by mini-css-extract-plugin
module.exports = {"container":"mini-course_container__7yFYf","image":"mini-course_image__OSixr","text":"mini-course_text__f3fcM"};